import { render, staticRenderFns } from "./atlasDetail.vue?vue&type=template&id=9c908bac&scoped=true&"
import script from "./atlasDetail.vue?vue&type=script&lang=js&"
export * from "./atlasDetail.vue?vue&type=script&lang=js&"
import style0 from "./atlasDetail.vue?vue&type=style&index=0&id=9c908bac&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./atlasDetail.vue?vue&type=style&index=1&id=9c908bac&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c908bac",
  null
  
)

export default component.exports